import { SITE_NAME, SITE_URL, LOGO_ABSOLUTE_URL } from '@/config/gbwaps';

/** 博客文章 Article 结构化数据 */
export function buildArticleSchema(article) {
	const path = `/blog/${article.slug}/`;
	return {
		'@context': 'https://schema.org',
		'@type': 'Article',
		headline: article.h1,
		description: article.meta.description,
		author: {
			'@type': 'Organization',
			name: SITE_NAME,
		},
		publisher: {
			'@type': 'Organization',
			name: SITE_NAME,
			logo: {
				'@type': 'ImageObject',
				url: LOGO_ABSOLUTE_URL,
			},
		},
		datePublished: article.datePublished,
		dateModified: article.dateModified,
		mainEntityOfPage: `${SITE_URL}${path}`,
	};
}
